import React from 'react';

const WarningTriangleIconSmall = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
    <path d="M8.572 3.212a1.5 1.5 0 0 1 2.856 0l5.676 11.073A1.5 1.5 0 0 1 15.676 16.5H4.324a1.5 1.5 0 0 1-1.428-2.215L8.572 3.212Z" stroke="#0A1938" strokeWidth="1.5" fill="none"/>
    <path d="M10 7.5v3" stroke="#0A1938" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="10" cy="13" r="0.75" fill="#0A1938"/>
  </svg>
);

export default WarningTriangleIconSmall;
